var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBookOpen = function SvgBookOpen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8274 0.223932C16.9246 0.33192 13.1426 0.724982 10.8078 2.15417C10.6467 2.25279 10.5554 2.42814 10.5554 2.61147V15.2461C10.5554 15.6471 10.9939 15.9006 11.3637 15.7145C13.7659 14.5054 17.2399 14.1756 18.9576 14.0853C19.5441 14.0544 20 13.5842 20 13.0207V1.28992C20.0003 0.674981 19.467 0.18782 18.8274 0.223932ZM9.19217 2.15417C6.85776 0.724982 3.07575 0.332267 1.17294 0.223932C0.533343 0.18782 0 0.674981 0 1.28992V13.021C0 13.5849 0.455911 14.0551 1.04238 14.0856C2.76081 14.1759 6.23657 14.5061 8.63869 15.7159C9.00745 15.9016 9.44461 15.6485 9.44461 15.2485V2.60522C9.44461 2.42154 9.35364 2.25313 9.19217 2.15417Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBookOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/book_open.1347ac96.svg";
export { ForwardRef as ReactComponent };